import { render, staticRenderFns } from "./AppEditRedirects.vue?vue&type=template&id=7f2806b9&scoped=true"
import script from "./AppEditRedirects.vue?vue&type=script&lang=js"
export * from "./AppEditRedirects.vue?vue&type=script&lang=js"
import style0 from "./AppEditRedirects.vue?vue&type=style&index=0&id=7f2806b9&prod&scoped=true&lang=scss"
import style1 from "./AppEditRedirects.vue?vue&type=style&index=1&id=7f2806b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2806b9",
  null
  
)

export default component.exports